module.exports = {"620103001":"西园街道","620103002":"西湖街道","620103003":"建兰路街道","620103004":"敦煌路街道","620103005":"西站街道","620103006":"晏家坪街道","620103007":"龚家湾街道","620103008":"土门墩街道","620103009":"秀川街道","620103100":"阿干镇","620103101":"八里镇","620103102":"彭家坪镇","620103103":"西果园镇","620103104":"黄峪镇","620103201":"魏岭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620103.json
// module id = 2891
// module chunks = 0